<template>
  <div class="select-container" :id="content.key">
    <div class="reset" @click.stop="reset"></div>
    <div class="select-list">
      <div class="select-item" v-for="item in content.content.selectOptions" :key="item.key">
        <div class="select-checkbox">
          <el-checkbox label="" :name="content.key" v-model="item.checked" :true-label="1" :false-label="0"></el-checkbox>
        </div>
        <div class="select-img">
          <img :src="item.imgUrl" alt="">
        </div>
        <div class="select-text-box">
          <div class="select-text-label">{{ item.label }}</div>
          <div class="select-text">{{ item.text }}</div>
        </div>
      </div>
    </div>
    <div class="select-submit" @click.stop="submitHandle">提交</div>
  </div>
</template>
<script>
/*
英语中带图片的选择
*/
export default {
  name: "selectWithImage",
  props: {
    content: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      checkVal: []
    }
  },
  methods: {
    reset() {
      this.content.content.selectOptions.forEach((item, index) => {
        this.$set(this.content.content.selectOptions[index], 'checked', 0)
      })
    },
    submitHandle() {
      let isComplete = false;
      this.content.content.selectOptions.forEach(item => {
        if(item.checked === 1) {
          isComplete = true
        }
      })
      if(!isComplete) {
        this.$message.error('请进行作答！')
      }else{
        this.$message.success('提交成功！')
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.select-container{
  width: calc(100% - 48rem);
  margin: 54rem auto 48rem;
  position: relative;

  .reset{
    width: 44rem;
    height: 44rem;
    background: url(~@/assets/images/books/bookExample/reset.png) center center no-repeat;
    background-size: contain;
    position: absolute;
    top: -56rem;
    right: 0;
    cursor: pointer;
  }
  
  .select-list{
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    margin-bottom: 10rem;

    .select-item{
      width: 340rem;
      height: 380rem;
      border: 1rem solid #5CA683;
      border-radius: 10rem;
      background: #fff;
      margin-bottom: 20rem;
      position: relative;

      .select-checkbox{
        position: absolute;
        top: 12rem;
        left: 12rem;
        width: 36rem;
        height: 36rem;

        /deep/.el-checkbox{
          .el-checkbox__input{
            .el-checkbox__inner{
              width: 36rem;
              height: 36rem;
              border: 2rem solid #F48450;
              &:after {
                width: 8rem;
                height: 14rem;
                font-weight: bold;
                border: 3rem solid #fff;
                border-left: 0;
                border-top: 0;
                left: 10rem;
                top: 5rem;
              }
            }
          }
          .el-checkbox__input.is-checked{
            .el-checkbox__inner{
              background-color: #F48450;
            }
          }
        }
      }

      .select-img{
        width: 251rem;
        height: 221rem;
        margin: 22rem auto 5rem;

        img{
          display: block;
          width: 251rem;
          height: 221rem;  
        }
      }

      .select-text-box{
        padding: 0 20rem;
        display: flex;
        font-size: 28rem;
        line-height: 38rem;
        color: #333;
        font-family: Calibri;
        display: flex;
        justify-content: flex-start;

        .select-text-label{
          flex: 0 0 38rem;

        }
      }
    }
  }
  .select-submit{
    width: 180rem;
    height: 52rem;
    background: #F6A84C;
    border-radius: 6rem;
    font-size: 26rem;
    line-height: 52rem;
    color: #fff;
    text-align: center;
    margin: 0 auto;
    cursor: pointer;
  }
}
</style>